module.exports = __webpack_public_path__ + "img/content2.dd4adc09.png";